// extracted by mini-css-extract-plugin
export default {"container":"J2x31W","title":"YhtDgB","link":"TdphkB","accessibilityThemeExtraPadding":"Y3QLkQ"};